import type React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { Print as PrintIcon, Close as CloseIcon } from "@mui/icons-material";
import InternetBookingForm from "./InternetAgreementForm";
import MemoryDeliveryNote from "./MemoryBookDeliveryNote";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface PrintDialogProps {
  open: boolean;
  onClose: () => void;
  documentType: "internet-form" | "memory-delivery-note";
}

const PrintDocument: React.FC<PrintDialogProps> = ({
  open,
  onClose,
  documentType,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" fontWeight="700">
            {documentType === "internet-form"
              ? "Internet Form Preview"
              : "Memory Delivery Note Preview"}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: reduxTheme.primary_colors?.[700] }}
        >
          Preview and print the document
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        {documentType === "internet-form" ? (
          <InternetBookingForm />
        ) : (
          <MemoryDeliveryNote />
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => window.print()}
          variant="contained"
          startIcon={<PrintIcon />}
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintDocument;
